<template>
  <v-dialog v-model="fullAdImageOne" fullscreen>
    <v-card>
      <v-img :src="`/create.png`" width="100%" height="100%" contain @click="closeDialog"></v-img>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data(){
    return{
      item: {},
      fullAdImageOne: false,
    }
  },
  methods: {
    openDialog(articledata) {
      this.fullAdImageOne = true;
    },
    closeDialog(){
      this.fullAdImageOne = false;
    }
  }
}
</script>